export default __webpack_public_path__ + "static/media/accounts-icon.e0bb164d.svg";